<template>
  <div>
    <div class="item-flex">
      <h5>{{ $t('pontos-de-manipulacao') }}</h5>
      <h5>{{ $t('art-cana-0') }}</h5>
    </div>
    <h6>{{ $t('perdas-determinadas') }}</h6>
    <div class="area">
      <div v-for="(det, i) in determinatedList" :key="i">
        <h6 v-if="det.name"> {{det.name}} </h6>
        <div :class="{'maxForScroll': (det.childrens.length > 5), 'sub-area': true, 'margin-top': (!det.name && determinatedList.length == 1)}">
          <div class="grid-model" v-for="(children, j) in det.childrens" :key="j">
            <span >
              <span v-for="(mi, k) in children.mi" :key="k">
                <label class="loss-variable" :title="mi.variable" for="manipulador">{{mi.variable}}</label>
                <b-input type="text" v-model.number="mi.value"  @change="(current) => setValue(current, mi)" />
              </span>
            </span>
            <p class="ml-2"> {{ children.mo.variable }} </p>
            <p> {{ children.mo.value }} </p>
          </div>
          <div v-if="det.name && det.childrens.length > 1" class="grid-model subTitle">
            <p></p>
            <p class="ml-2 mt-1">{{det.lastVariable}}</p>
            <p>{{det.lastValue}}</p>
          </div>
        </div>
      </div>
    </div>

    <h6>{{ $t('perdas-indeterminadas') }}</h6>
    <div class="area undetermined">
      <div class="sub-area" v-if="undeterminatedList.length">
        <div class="grid-model" v-for="(undet, l) in undeterminatedList" :key="l">
          <span>
            <span v-for="(mi, m) in undet.mi" :key="m">
              <label for="manipulador">{{mi.variable}}</label>
              <b-input type="text" v-model="mi.value" min="-10" step="0.01" @change="convertNumber(mi.value)" />
            </span>
          </span>
          <p class="ml-1">{{ undet.mo.variable }}</p>
          <p>{{undet.mo.value}}</p>
        </div>
      </div>
    </div>
  </div> 
</template>

<script>import { NumberFormatToNode } from "../../../../global"
import { ParseToNumber } from '../../../flowchart/utils/tools';

  export default {
    name:"ConfigLossToUserView",
    props:["determinatedList", "undeterminatedList"],
    data() {
      return {}
    },

    watch:{},

    methods: {
      setValue(value, map){
        map.value = NumberFormatToNode(value)
      },

      convertNumber(value) {
        let num = ParseToNumber(value);
        value = num;
      }
    },
    
    mounted() {},
  }
</script>

<style scoped>

p{
  margin: 0;
}

h6{
  text-align: center;
  margin-top: 8px;
}

.item-flex{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.area{
  border: 5px solid #aaa9;
  border-radius: 4px;
  padding: 0 8px;
}


.sub-area{
  border: 3px dashed #aaa9;
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 4px 0px;
}

.sub-area.margin-top,
.undetermined>.sub-area{
  margin-top: 16px;
}

.grid-model > span > span{
  display: grid;
  grid-template-columns: 70% 30%;
}

.grid-model > span input,
.sub-area > input{
  height: 27px;
  padding: 2px 5px;
  border: 1px solid #ff5f00;
  border-radius: 4px;
  text-align: right;
}

.grid-model > span input:focus,
.sub-area > input:focus{
  border: 1px solid #ff5f00;
  box-shadow: 0px 0px 5px #ff5f00;
  outline: none; 
}

.loss-variable{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden; 
}

.maxForScroll {
  position: relative; 
  height: 180px;
  text-overflow: ellipsis;
  overflow-x: hidden;
} 

.grid-model{
  display: grid;
  grid-template-columns: 50% 37% 13%;
  align-items: center;
  padding: 0px 4px;
}

</style>